import * as api from '@api/auth'

export const login = ({commit}, {email, password}) => {
  return api.login(email, password)
    .then((token) => {
      window.localStorage.setItem('jwt', token)
      commit('login', JSON.parse(atob(token.split('.')[0])).user)
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js